import script from "./ComputePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComputePage.vue?vue&type=script&setup=true&lang=ts"

import "./ComputePage.vue?vue&type=style&index=0&id=3e50c938&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e50c938"]])

export default __exports__